module.exports = __webpack_public_path__ + "img/homepage-interest-yellow.0a5950fd.svg";